import type { AchievementsResponse } from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type { AchievementTier, Achievement, AchievementsResponse } from "@atlas/shared";

export function fetchAchievements(): Promise<AchievementsResponse> {
  return apiGet("/achievements");
}

/** Pre-signed link to the shareable trophy card (PLT-3) for an unlocked achievement. */
export function fetchAchievementShareUrl(id: string): Promise<{ url: string }> {
  return apiGet(`/achievements/${id}/share-url`);
}
